import { PluginReviewActionNotAllowedError } from "~/lib/AjaxCtx"

export const mutations = {
    "presential/setEventAttend"(state, { eventConfirm, userActivityId }) {
        const activity = state.userActivities[userActivityId]
        activity.state.eventConfirm = eventConfirm
    },
}

export function makeActions(service) {
    return {
        async setEventAttend(
            { commit, dispatch },
            { eventId, eventConfirm, userActivityId }
        ) {
            try {
                await service.pushAttendToEvent(eventId, eventConfirm)
                commit("presential/setEventAttend", {
                    eventConfirm,
                    userActivityId,
                })
            } catch (error) {
                if (error instanceof PluginReviewActionNotAllowedError) {
                    dispatch("lms/refreshUserActivity", userActivityId, {
                        root: true,
                    })
                    return
                }
                dispatch(
                    "pushNotification",
                    {
                        title: error.message,
                        type: "error",
                    },
                    { root: true }
                )
            }
        },
    }
}

export default {
    mutations,
    makeActions,
}
